function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-99.419 -110.938)",
  id: "layer1",
  fill: "none",
  stroke: "#f9f9f9",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 1
}, /*#__PURE__*/React.createElement("path", {
  d: "M139.956 114.878c-6.13-1.826-12.535-3.92-19.006-3.025-2.99 1.119-6.302 2.014-8.706 4.231-2.991 1.386-5.714 3.428-7.488 6.258-2.962 3.987-3.681 9.092-4.479 13.864-.573 2.786.702 5.453.61 8.234.058.957.55 2.962 1.049 3.61 1.013 2.597 2.294 4.7 3.94 6.967 3.172 3.645 6.03 7.774 10.188 10.374 4.846 2.16 10.388 1.433 15.399.256 2.338-.554 4.743.009 7.053-.876 3.642-1.373 7.419-2.91 10.308-5.578 1.973-2.762 4.21-5.615 4.832-9.025.202-4.59.937-9.227.284-13.83-.242-3.04-1.5-5.805-2.657-8.551-1.53-2.145-1.773-4.923-3.246-7.085-.537-1.553-1.306-3.103-2.253-3.86-1.643-1.387-3.771-1.594-5.828-1.964z",
  id: "path3104"
}), /*#__PURE__*/React.createElement("path", {
  d: "M118.84 147.432c.04 2.435 2.067 5.185 4.47 6.19 1.83.685 5.096.524 7.194.387 3.125-.418 6.225-4.468 5.94-6.986",
  id: "path3108"
}), /*#__PURE__*/React.createElement("path", {
  d: "M119.109 130.079c-4.008-2.076-5.85 5.33-.52 3.846 1.802-.47 1.926-2.658.52-3.846",
  id: "path3110"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.457 130.518c-2.451-1.234-4.53.68-3.853 3.234 1.65 1.21 5.389 1.386 4.731-1.744-.19-.55-.54-1.024-.878-1.49z",
  id: "path3112"
}));

var SvgHappy = function SvgHappy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2537",
    viewBox: "0 0 55.489 56.543",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHappy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/happy.0a905c76.svg";
export { ForwardRef as ReactComponent };